import type { AxiosRequestConfig } from 'axios';

/**
 * 业务错误类
 * 拦截器解包 ResData 时，业务码非 200 统一抛出 BizError
 * 调用方可通过 err.code 差异化处理不同业务错误
 *
 * @example
 * try {
 *   await someApi();
 * } catch (err) {
 *   if (err instanceof BizError && err.code === '403') {
 *     showPermissionDialog();
 *   } else {
 *     setError(err.message);
 *   }
 * }
 */
export class BizError extends Error {
  /** 业务状态码（后端 ResData.code） */
  public readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = 'BizError';
    this.code = code;
  }
}

/** HTTP 客户端类型 */
export type HttpClientType = 'user' | 'cs';

/** HTTP 客户端配置 */
export interface HttpClientConfig {
  /** 客户端类型 */
  type: HttpClientType;
  /** 自定义 baseURL（可选，默认从环境变量读取） */
  baseURL?: string;
  /** 自定义超时时间（可选，默认 120000ms） */
  timeout?: number;
}

/** HTTP 客户端实例接口 */
export interface HttpClient {
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T>;
  post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T>;
  put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T>;
  delete<T>(url: string, config?: AxiosRequestConfig): Promise<T>;
  request<T>(config: AxiosRequestConfig): Promise<T>;
}
